import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "preferential_body"
};
const _hoisted_2 = {
  class: "navbat"
};
const _hoisted_3 = {
  key: 0,
  class: "dialog_body"
};
const _hoisted_4 = {
  class: "time"
};
const _hoisted_5 = {
  class: "dialog_info"
};
const _hoisted_6 = {
  class: "info_name"
};
const _hoisted_7 = {
  class: "l"
};
const _hoisted_8 = {
  class: "info_code"
};
const _hoisted_9 = {
  class: "dialog_tip"
};
const _hoisted_10 = {
  style: {
    "margin-top": "10px"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_vue_qr = _resolveComponent("vue-qr");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("img", {
    src: "https://www.mimodental.com/assets/imgData/imgs/fh.png",
    alt: "",
    onClick: _cache[0] || (_cache[0] = (...args) => $setup.fh && $setup.fh(...args))
  }), _cache[1] || (_cache[1] = _createElementVNode("span", null, "优惠卷详情", -1))]), $setup.dialog_data ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_cache[8] || (_cache[8] = _createElementVNode("div", {
    class: "state"
  }, [_createElementVNode("img", {
    src: "https://www.mimodental.com/assets/imgData/img/member_preferential/time.png",
    alt: ""
  }), _createElementVNode("span", null, "待到店使用")], -1)), _createElementVNode("div", _hoisted_4, [_createElementVNode("span", null, "请在" + _toDisplayString($setup.dialog_data.endDateStr) + "前到店使用", 1)]), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("span", null, "卷码信息（" + _toDisplayString($setup.dialog_data.title) + "）", 1), _createElementVNode("div", null, [_createElementVNode("div", _hoisted_7, [_cache[2] || (_cache[2] = _createElementVNode("div", {
    class: "dian"
  }, null, -1)), _createElementVNode("span", null, _toDisplayString($setup.dialog_data.code), 1)]), _cache[3] || (_cache[3] = _createElementVNode("div", {
    class: "r"
  }, [_createElementVNode("span", null, "待使用")], -1))])]), _cache[4] || (_cache[4] = _createElementVNode("div", {
    class: "xian",
    style: {
      "height": "1px"
    }
  }, null, -1)), _createElementVNode("div", _hoisted_8, [_createVNode(_component_vue_qr, {
    logoSrc: require('../../../public/smalllogo.png'),
    text: $setup.dialog_data.code,
    size: "400"
  }, null, 8, ["logoSrc", "text"])])]), _cache[9] || (_cache[9] = _createElementVNode("div", {
    class: "dialog_address"
  }, [_createElementVNode("div", null, [_createElementVNode("span", null, "米檬口腔（珠江新城店）"), _createElementVNode("div", null, [_createElementVNode("span", null, "黄埔大道西高志大厦3楼")])]), _createElementVNode("div", null, [_createElementVNode("span", null, "米檬口腔（黄埔旗舰店）"), _createElementVNode("div", null, [_createElementVNode("span", null, "开创大道雪松中心103铺")])]), _createElementVNode("div", null, [_createElementVNode("span", null, "米檬口腔（番禺青春店）"), _createElementVNode("div", null, [_createElementVNode("span", null, "广州市番禺区钟村街文都二街6号(保利大都汇北侧)")])])], -1)), _createElementVNode("div", _hoisted_9, [_cache[7] || (_cache[7] = _createElementVNode("h3", null, "温馨提示", -1)), _createElementVNode("div", _hoisted_10, [_createElementVNode("div", null, [_cache[5] || (_cache[5] = _createElementVNode("span", null, "有效期：", -1)), _createElementVNode("span", null, "有效期至" + _toDisplayString($setup.dialog_data.endDateStr) + "前使用", 1)]), _createElementVNode("div", null, [_cache[6] || (_cache[6] = _createElementVNode("span", null, "使用规则：", -1)), _createElementVNode("span", null, _toDisplayString($setup.dialog_data.description), 1)])])])])) : _createCommentVNode("", true)]);
}